let CURRENT_GST_RATE = 0;
function gstData(t) {
  CURRENT_GST_RATE = Number(t) || 0;
}
function updateCartCount() {
  setTimeout(() => {
    fetch("/cart.js")
      .then((t) => t.json())
      .then((t) => updateCartBubble(t.item_count));
  }, 1e3);
}
function updateCartNotification(t) {
  if (!t || !t.title) return;
  const n = CURRENT_GST_RATE,
    a = Number(t.presentment_price),
    e = Math.round(a + (a * n) / 100),
    i = Math.round(t.quantity),
    o = `\n    <div class="cart-notification-product__image global-media-settings">\n      <img\n        src="${t.image || t.featured_image?.url || ""}"\n        alt="${t.title}"\n        width="70"\n        height="70"\n        loading="lazy">\n    </div>\n    <div>\n      <h3 class="cart-notification-product__name h4">\n        ${t.title}\n      </h3>\n\n       <div class="releaf-qty-price">\n       <dl>\n         <div class="product-option releaf-related-product-mini">\n          <p class="cart-item-quantity">Qty: ${i}</p>\n        </div>\n        <div class="product-option">\n         <p class="cart-item-price">Rs. ${e}</p>\n        </div>\n      </dl>\n       </div>\n    </div>\n  `;
  $("#cart-notification-product").empty().append(o);
}
function openCartNotification() {
  const t = $("#cart-notification");
  t.length &&
    (t.removeAttr("hidden").attr("aria-hidden", "false").addClass("active"),
    $("body").addClass("overflow-hidden"));
}
function updateCartBubble(t) {
  const n = document.querySelector("#cart-icon-bubble");
  if (!n) return;
  const a = n.querySelector(".cart-count-bubble");
  a && a.remove();
  const e = n.querySelector(".visually-hidden");
  if ((e && e.remove(), t <= 0)) return;
  const i = document.createElement("span");
  ((i.className = "visually-hidden"), (i.textContent = "Cart"));
  const o = document.createElement("div");
  ((o.className = "cart-count-bubble"),
    (o.innerHTML = `\n    <span aria-hidden="true">${t}</span>\n    <span class="visually-hidden">${t} items</span>\n  `),
    n.appendChild(i),
    n.appendChild(o));
}
(document.addEventListener("click", function (t) {

  const n = t.target.closest(".related-add");
  if (!n) return;

  t.preventDefault();
  t.stopImmediatePropagation();

  const variantId = n.getAttribute("data-variant-id"),
        gstRate = n.getAttribute("data-gst-rate");

  if (!variantId) return;

  //console.log("variantId", variantId);

  gstData(gstRate);
  n.disabled = true;

  fetch("/cart.js")
    .then(res => res.json())
    .then(cart => {

      let existingItem = cart.items.find(
        item => item.variant_id == variantId
      );

      if (existingItem) {

        /* UPDATE QUANTITY */
        /* ADD NEW PRODUCT */

        $.ajax({
          url: "/cart/add.js",
          method: "POST",
          dataType: "json",
          data: {
            id: variantId,
            quantity: 1,
            properties: {
              _gst_rate: gstRate
            }
          },
          success: function (data) {
            updateCartNotification(data);
            updateCartCount();
            openCartNotification();
            $("#cart-notification").addClass("active");
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            $("#cart-notification-product").removeClass("releaf-noti-cart-mini-detailspage");
          },
          error: function () {
            console.log("Error adding product to cart");
          },
          complete: function () {
            n.disabled = false;
          }
        });

      }else{


         $.ajax({
          url: "/cart/add.js",
          method: "POST",
          dataType: "json",
          data: {
            id: variantId,
            quantity: 1,
            properties: {
              _gst_rate: gstRate
            }
          },
          success: function (data) {
            updateCartNotification(data);
            updateCartCount();
            openCartNotification();
            $("#cart-notification").addClass("active");
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            $("#cart-notification-product").removeClass("releaf-noti-cart-mini-detailspage");
          },
          error: function () {
            console.log("Error adding product to cart");
          },
          complete: function () {
            n.disabled = false;
          }
        });

      }

    });

})),
 $(document).on(
  "click",
  ".cart-notification__close, .cart-notification__links button.link",
  function () {

    $("#cart-notification")
      .attr("aria-hidden", "true")
      .removeClass("active");

    $("body").removeClass("overflow-hidden");

  }
);
